import styled from 'styled-components'
import { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink } from '../../styles/styled-elements'
import styledTheme from '../../styles/theme'

//export { H1, GridContainer, ContainerHeading, GridSection, Row, Column, ActionLink, styledTheme }

export const GaugeSetContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0px;
  width: 100%;
  border: none;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media (max-width: 400px) {
    justify-content: space-around;
  }
`
export const GaugeContainer = styled.div`
  display: inline-flex;
  width: 200px;
  background-color: white;
  border: 1px solid black;
  padding: 10px;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 10px;
  @media (max-width: 700px) {
    &:last-child {
      margin-right: 0px;
    }
  }
  @media (max-width: 550px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`
export const GaugeHeading = styled.div`
  display: block;
  width: 300px;
  padding: 6px;
`
export const GaugePlusDetailsContainer = styled.div`
  display: inline-flex;
  width: 220px;
  background-color: white;
  border: 1px solid #CCC;
  border-radius: 5px;
  padding: 6px;
  flex-direction: column;
  margin-right: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  @media (max-width: 700px) {
  }
  @media (max-width: 400px) {
    width: 176px;
    margin-right: 0;
    padding: 2px;
    margin-bottom: 6px;
  }
`
export const GaugePlusDetailsHeading = styled.div`
  display: block;
  padding: 6px;
`
export const InnerGaugeContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: -30px;
  overflow: hidden;
  @media (max-width: 700px) {
    &:last-child {
      margin-right: 0px;
    }
  }
  @media (max-width: 550px) {
    margin-left: 0px;
    margin-right: 0px;
    margin-left: 4px;
    margin-right: 4px;
  }
`
export const GaugePlusDetailsSparklineContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 40px;
`
export const GaugePlusDetailsMinMaxAvgContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
`
export const GaugePlusDetailsMinMaxAvgRow = styled.div`
  display: inline-flex;
  flex-direction: row;
  padding: 0.2rem;
  justify-content: center;
`
export const GaugePlusDetailsMinMaxAvgRowHeading = styled.div`
  font-size: 0.7rem;
  font-weight: 700;
  margin-right: 0.2rem;
`
export const GaugePlusDetailsMinMaxAvgRowDetail = styled.div`
  font-size: 0.7rem;
  font-weight: 400;
`
export const DataViewContainer = styled.div`
  display: flex;
  background-color: white;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  border: 1px solid #CCC;
  border-radius: 5px;
  margin-bottom: 20px;
`
export const DataViewHeadingDiv = styled.div`
  display: block;
  width: 100%;
  padding: 6px;
`
export const DataViewHeadingText = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  @media (max-width: 400px) {
    font-size: 14px;
    font-weight: 500;
  }
`
export const DataViewHeadingLinks = styled.span`
  vertical-align: 3px;
`
export const DataViewBody = styled.div`
  display: block;
  padding: 6px;
`
export const DashboardGraphHeadingExpandLinkCell = styled.div`
  display: inline-flex;
  padding-right: 10px;
  align-items: flex-end;
`
export const DashboardGraphHeadingExpandLink = styled.span`
  padding: 2px 4px;
  border-radius: 3px;
  background-color: ${styledTheme.colors.button_background};
  color: #FFF;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.6rem;
`




// WEBPACK FOOTER //
// ./src/containers/dashboard/styled-elements.js